// extracted by mini-css-extract-plugin
export default {"logoText":"selectCity_logoText__rWpDG","city":"selectCity_city__-Dok9","geoPopup":"selectCity_geoPopup__aup-Y","yourCity":"selectCity_yourCity__CWAZj","btn":"selectCity_btn__T84pj"};